import Projects from "../../components/user/projects/Projects";
import UserTemplate from "../../views/UserTemplate";

const ProjectsPage = () => {
  return (
    <UserTemplate>
      <Projects />
    </UserTemplate>
  );
};

export default ProjectsPage;
